import { translate } from '../translation';
import { getLabel } from './view_state';
import { isLeafOption } from './selection_handler';

export const getDisplayText = (selectedOptions) => {
  if (!selectedOptions.length) {
    return '';
  }

  if (selectedOptions.length === 1) {
    return getLabel(selectedOptions[0]);
  }

  return selectedOptions
    .filter(isLeafOption)
    .map((option) => option.label)
    .join(', ');
};

export const getAccordionLabel = (selectedOptions) => {
  if (!selectedOptions.length) {
    return null;
  }

  const selectedLeafOptions = selectedOptions.filter(isLeafOption);
  if (selectedLeafOptions.length > 1) {
    return translate('common.search_form.accordion.multiple_value_selected', { count: selectedLeafOptions.length });
  }

  return (selectedLeafOptions[0] ?? selectedOptions[0]).label;
};
